export default "__VITE_ASSET__DIYU0A_p__"